import { IUploaderProps } from "./Uploader.props";
import styles from "./Uploader.module.scss";
import cn from "classnames";
import { Modal, Upload } from "antd";
import { InboxOutlined, PlusOutlined } from "@ant-design/icons";
import { useUploaderControl } from "./useUploaderControl";
import { useIntl } from "react-intl";

const { Dragger } = Upload;

export default function Uploader({ ...props }: IUploaderProps) {
  const { formatMessage } = useIntl();
  const control = useUploaderControl(props);
  return (
    <>
      <div className={styles.wrapper}>
        <div
          className={cn({
            [styles.max_count]: !control.canUpload,
          })}
        >
          {!control.canUpload && (
            <p className={styles.max_count__text}>
              {formatMessage({ id: "modal.upload_photo.max_count" })}
            </p>
          )}
          <Dragger
            accept='.jpg,.jpeg,.png,.webp,.gif'
            action={"https://www.mocky.io/v2/5cc8019d300000980a055e76"}
            onRemove={control.onDelete}
            customRequest={control.onUpload}
            onPreview={(data) => control.onOpenPreview(data)}
            fileList={control.fileList}
            maxCount={5}
            showUploadList={false}
            name='File'
          >
            <p className='ant-upload-drag-icon'>
              <InboxOutlined rev={undefined} />
            </p>
            <p className={styles.upload_text}>
              {formatMessage({ id: "modal.upload_photo.drop_text" })}
            </p>
            <p className={styles.types}>jpg, jpeg, png, webp, gif</p>
          </Dragger>
        </div>

        <Upload
          className={styles.list}
          listType='picture-card'
          fileList={control.fileList}
          onRemove={control.onDelete}
          onPreview={(data) => control.onOpenPreview(data)}
        />
      </div>
      <Modal
        open={control.previewOpen}
        footer={null}
        onCancel={control.onClosePreview}
        title={control.preview?.name || control.preview?.fileName}
      >
        <img
          alt='example'
          style={{ width: "100%" }}
          src={control.preview?.url || control.preview?.thumbUrl}
        />
      </Modal>
    </>
  );
}
